import { g } from '@pretto/bricks/components/layout'
import BaseTypo from '@pretto/bricks/components/typography/BaseTypo'
import { bodyMedium16 } from '@pretto/bricks/core/typography'

import styled, { css } from 'styled-components'

export const TooltipContainer = styled.div`
  display: inline-block;
  position: relative;
`

export const Tooltip = styled.div`
  ${bodyMedium16};
  background-color: ${({ theme }) => theme.colors.neutral1};
  border-radius: ${g(1)};
  color: ${({ theme }) => theme.colors.white};
  line-height: 1;
  opacity: 0;
  padding: ${g(2)};
  position: absolute;
  transition: all 200ms ease-in-out;
  visibility: hidden;
  z-index: 1000;
  max-width: 226px;

  &::after {
    border: ${g(1)} solid transparent;
    content: '';
    position: absolute;
  }

  ${({ $position, theme }) => {
    switch ($position) {
      case 'bottom':
        return css`
          top: 100%;
          left: 50%;
          transform: translate(-50%, 0);

          &::after {
            left: 50%;
            bottom: 100%;
            transform: translateX(-50%);
            border-bottom-color: ${theme.colors.neutral1};
          }

          ${TooltipContainer}:hover && {
            transform: translate(-50%, ${g(1.5)});
          }
        `
      case 'right':
        return css`
          top: ${g(-3)};
          left: 100%;

          &::after {
            top: ${g(3)};
            right: 100%;
            border-right-color: ${theme.colors.neutral1};
          }

          ${TooltipContainer}:hover && {
            transform: translate(${g(1.5)}, 0);
          }
        `
      case 'left':
        return css`
          top: ${g(-3)};
          right: 100%;

          &::after {
            top: ${g(3)};
            left: 100%;
            border-left-color: ${theme.colors.neutral1};
          }

          ${TooltipContainer}:hover && {
            transform: translate(${g(-1.5)}, 0);
          }
        `

      case 'top':
      default:
        return css`
          left: 50%;
          bottom: 100%;
          transform: translate(-50%, 0);

          &::after {
            left: 50%;
            top: 100%;
            transform: translateX(-50%);
            border-top-color: ${theme.colors.neutral1};
          }

          ${TooltipContainer}:hover && {
            transform: translate(-50%, ${g(-1.5)});
          }
        `
    }
  }}

  ${({ $isOneLiner }) =>
    $isOneLiner &&
    css`
      white-space: nowrap;
    `}

  ${TooltipContainer}:hover & {
    opacity: 1;
    visibility: visible;
  }
`
